const BpmnValidation = [
    {
        bpmn: "userTask",
        camunda: "formKey"
    },
    {
        bpmn: "serviceTask",
        camunda: "topic"
    },
]

export default function formValidation(findTask: any, isValidForm: any) {
    for (let task in findTask) {
        if (task === "bpmn:subProcess") {
            if (findTask[ task ].length > 1) {
                for (let i of findTask[ task ]) {
                    isValidForm = formValidation(i, isValidForm)
                }
            } else {
                isValidForm = formValidation(findTask[ task ][ 0 ], isValidForm)
            }
            if (!isValidForm) {
                break;
            }
        } else {
            for (let el of BpmnValidation) {
                if (findTask[ `bpmn:${el.bpmn}` ]) {
                    for (let userTask of findTask[ `bpmn:${el.bpmn}` ]) {
                        if (!userTask[ "$" ][ `camunda:${el.camunda}` ]) {
                            isValidForm = false
                            break;
                        }
                    }
                    if (!isValidForm) {
                        break
                    }
                }
            }
        }
    }
    return isValidForm;
}